import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map, of} from 'rxjs';
import {UrlService} from '../url.service';

@Injectable()
export class DocumentService {
    private documentTypes: any;
    private readonly BASE_URL: string;

    constructor(private http: HttpClient,
                private urlService: UrlService) {
        this.BASE_URL = this.urlService.getBackendUrl() + 'data/v2/documents';
    }

    getDocuments(params) {
        const requestParams = {
            params: params
        }

        return this.http.get(this.BASE_URL, requestParams);
    }

    // Get all the document types from the database.
    getDocumentTypes() {
        // Load up and keep a reference to the DocumentTypes.
        // They don't change much so should be safe.
        if (this.documentTypes) {
            return of(this.documentTypes);
        } else {
            return this.http.get(this.BASE_URL + '/types').pipe(
                map(types => {
                    this.documentTypes = types;
                    return types;
                })
            );
        }
    }

    getDocument(documentId, clientId) {
        return this.http.get(this.BASE_URL + '/' + clientId + '/get/' + documentId);
    }

    uploadDocument(file, clientId) {

        const fd = new FormData();
        fd.append('file', file);
        fd.append('clientId', clientId);

        const requestOptions: Object = {
            contentType: undefined
        }

        return this.http.post(this.BASE_URL + '/upload', fd, requestOptions);

        // HACK WORKAROUND
        //
        // There seems to be a bug in Restangular where the Default Headers cannot be overridden, despite
        // the syntax that indicates they should.  So, overwrite Content-Type header to be
        // undefined.  Restore whatever is there once the call is finished.
        //
        // let currentContentTypeDefaultHeader = undefined;
        // if (Restangular.configuration.defaultHeaders['Content-Type']) {
        //     currentContentTypeDefaultHeader = Restangular.configuration.defaultHeaders['Content-Type'];
        //     Restangular.configuration.defaultHeaders['Content-Type'] = undefined;
        // }
        // var promise = Restangular.one('documents/upload')
        //     .withHttpConfig({transformRequest: angular.identity})
        //     .customPOST(fd);
        // if (currentContentTypeDefaultHeader) {
        //     Restangular.configuration.defaultHeaders['Content-Type'] = currentContentTypeDefaultHeader;
        // }

        // return promise;
    }

    updateDocument(documentId, clientId, document) {
        return this.http.put(this.BASE_URL + '/' + clientId + '/update/' + documentId, document);
    }

    downloadDocument(documentId, clientId) {
        const requestOptions: Object = {
            responseType: 'blob'
        }

        return this.http.get(this.BASE_URL + '/' + clientId + '/download/' + documentId, requestOptions);
    }

    deleteDocument(documentId, clientId) {
        return this.http.delete(this.BASE_URL + '/' + clientId + '/delete/' + documentId);
    }
}
